import { AxiosRequestConfig } from "axios";

import { ApiError, NewNotification, Notification } from "@/types";
import { fetchData } from "@/utils";

type GetNotificationsApiResponse = {
  data: Notification[];
  error: ApiError | null;
};

export const getNotifications = async (
  accessToken: string,
  client: string
): Promise<GetNotificationsApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/notifications?client=${client}`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

export const clearNotification = async (
  accessToken: string,
  client: string,
  notificationId: string,
): Promise<GetNotificationsApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/notifications/${notificationId}/read?client=${client}`;

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

export const clearAllNotifications = async (
  accessToken: string,
  client: string,
): Promise<GetNotificationsApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/notifications/read?client=${client}`;

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};


export const createNotification = async (
  accessToken: string,
  notification: NewNotification,
): Promise<GetNotificationsApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/notifications`;

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data: notification,
  };

  return fetchData(config);
};
